import { FilterKey } from '@services/filters/types';
import { kebabToCamelCase } from '@utils/textHelpers';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

const KEYS: FilterKey[] = [
  'hotSeat',
  'workload',
  'onDeck',
  'map',
  'jobs',
  'users',
  'builders',
  'inventory',
  'tenants',
  'admins',
];

export const useFilterKey = () => {
  const { pathname } = useLocation();
  const [key, setKey] = useState<FilterKey>();

  useEffect(() => {
    const newKey = KEYS.find((el) => kebabToCamelCase(pathname.replace('panel/', '')).endsWith(el));
    setKey(newKey);
  }, [pathname]);

  return key as FilterKey;
};
